import axios from 'axios'

export default {
  async index (params) {
    return await axios.get('/api/spa/v1/breaking-news', { params })
  },
  async findById (id) {
    return await axios.get('/api/spa/v1/breaking-news/' + id)
  },
  async store (params) {
    return await axios.post('/api/spa/v1/breaking-news', params)
  },
  async update (params) {
    return await axios.put('/api/spa/v1/breaking-news/' + params.id, params)
  },
  async delete (id) {
    return await axios.delete('/api/spa/v1/breaking-news/' + id)
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

}
